<template>
  <section class="d-flex flex-column h-full">
    <header class="mdc-top-app-bar" v-if="!showImagePreview">
      <div class="mdc-top-app-bar__row">
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
          <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
            aria-label="Open navigation menu" @click="goToBack" @keypress="goToBack" tabindex="0">
            close
          </button>
        </section>
        <section class="mdc-top-app-bar__section title d-flex justify-content-center">
          <div class="mdc-top-app-bar__title pdl-1">{{ $t("3361") }}</div>
        </section>
        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
          <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button"
            aria-label="Open navigation menu" tabindex="0"></button>
        </section>
      </div>
    </header>
    <main class="mdc-top-app-bar--fixed-adjust" v-if="!showImagePreview">
      <div class="pdb-18 d-flex flex-column" v-if="distributionDetail">
        <div class="flex-grow-1 scroll-y checklist-comment-toggler bg-documentGray">
          <div class="d-flex">
            <!-- User Profile Image 휴면, 탈퇴 처리 -->
            <UserImgProfile :allData="distributionDetail" class="pdl-16 pdt-16 checklist-profile-img"
              :data="distributionDetail.member" />

            <div class="flex-grow-1 mgt-16 mgl-16 mgb--1">
              <div class="t-body3 font-r l-spacing42 t-line-h-20">
                {{ handleUserName(distributionDetail.member) }}
              </div>
              <div class="mgt-1" v-if="checkDeactivateUser(distributionDetail.member)">
                <span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">
                  {{
                    distributionDetail.member.brandName
                      ? distributionDetail.member.brandName
                      : brandName
                  }}
                </span>
              </div>
              <div class="mgt-1" v-else>
                <span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">
                  {{ distributionDetail.member.dutyName }}
                </span>
                <span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">
                  {{ distributionDetail.member.responsibilityName }}
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="mgt-20 pdl-16 pdr-16">
            <span class="t-body4 font-r t-color-bodyGrayB">{{
              $t("3362")
            }}</span>
            <span class="t-color-bodyGrayA font-r t-body4 pdl-8">{{
              $moment(distributionDetail.startDate).format("YYYY.MM.DD hh:mm")
            }}</span>
          </div>
          <div class="mgt-8 pdl-16 pdr-16">
            <span class="t-body4 font-r t-color-bodyGrayB">{{
              $t("3363")
            }}</span>
            <span class="t-color-bodyGrayA font-r t-body4 pdl-8">{{
              distributionDetail.lastSubmitDate
                ? $moment(distributionDetail.lastSubmitDate).format(
                    "YYYY.MM.DD hh:mm"
                  )
                : ""
            }}</span>
          </div> -->
          <!-- <div class="mgt-8 pdl-16 pdr-16">
            <span class="t-body4 font-r t-color-bodyGrayB">{{
              $t("3364")
            }}</span>
            <span class="t-color-bodyGrayA font-r t-body4 pdl-8">
              {{ getDays > 0 ? getDays + " days " : "" }}
              {{ getHours > 9 ? getHours : "0" + getHours }}:{{
                getMinutes > 9 ? getMinutes : "0" + getMinutes
              }}:{{ getSeconds > 9 ? getSeconds : "0" + getSeconds }}
            </span>
          </div> -->
          <!-- <div class="pda-16">
            <div
              class="check-list-result d-flex justify-content-between pdl-14 pdr-16 pdt-16 pdb-16 b-radius4"
            >
              <div>
                <div class="t-body3 t-color-contentBlue font-r t-line-h-20">
                  {{ $t("3366") }}
                </div>
                <div class="t-body3 t-color-contentBlue font-r t-line-h-20">
                  {{ $t("3367") }}
                </div>
              </div>
              <div class="t-headline3 font-rb t-color-contentBlue">
                {{
                  distributionDetail.totalScore
                    ? distributionDetail.totalScore
                    : 0
                }}
              </div>
            </div>
          </div> -->
          <div class="pdt-16" />
          <div class="divider"></div>
          <div class="bg-documentGray pda-16" v-if="
            distributionDetail.activeRespondentPaper &&
            distributionDetail.activeRespondentPaper.groups.length > 0
          ">
            <div class="mdc-card mgb-16" v-for="(myData, index) in distributionDetail.activeRespondentPaper
              .groups" :key="index + myData.id">
              <div class="d-flex align-items-center justify-content-between pdt-16 pdb-16 pdl-16 pdr-16">
                <div class="t-subtitle3 font-m flex-grow-1">
                  {{ myData.name }}
                </div>
                <button class="mdc-icon-button content-trigger mgr--16 pdt-0 pdb-0 h-auto without-shadow">
                  <i v-if="index > 0" class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_down</i>
                  <i v-else class="material-icons t-headline12 t-color-bodyGrayA">keyboard_arrow_up</i>
                </button>
              </div>
              <div class="detail-content" :class="index > 0 ? 'd-none' : ''">
                <div class="divider"></div>
                <div class="pdt-4 pdb-4 pdl-16 pdr-10">
                  <div v-for="(innerData, indexInner) in myData.questions" :key="indexInner">
                    <div class="qa-wrapper pdt-16 pdb-16">
                      <div class="q-wrapper">
                        <div class="d-flex">
                          <div class="t-subtitle2 font-b t-nowrap">
                            Q{{ indexInner + 1 }}.
                          </div>
                          <div class="flex-grow-1 pdl-4">
                            <span class="t-body1 font-r l-spacing42">{{
                              innerData.question.contents
                            }}</span>
                            <!-- 개별 점수 주석 처리 -->
                            <!-- <span
                              class="t-body3 t-color-bodyGrayA pdl-2 l-spacing42"
                              >{{
                                $t("3368", {
                                  str1: innerData.answerScore,
                                  str2: innerData.question.score,
                                })
                              }}</span
                            > -->
                          </div>
                        </div>
                      </div>
                      <div class="a-wrapper pdt-11">
                        <span class="d-flex align-items-baseline">
                          <span class="t-subtitle2 font-b t-color-contentVariationInactive t-nowrap">A{{ indexInner + 1
                            }}.</span>
                          <span class="t-body3 font-r l-spacing42 pdl-4 t-color-bodyGrayA"
                            v-if="innerData.type == 'CHOICE_SINGLE'">
                            <span v-for="choiceData in innerData.choices" :key="choiceData.answerChoice.id">
                              {{
                                choiceData.weight == 1
                                  ? choiceData.answerChoice.contents
                                  : ""
                              }}
                            </span>
                          </span>
                          <span class="t-body3 font-r l-spacing42 pdl-4 t-color-bodyGrayA"
                            v-if="innerData.type == 'CHOICE_WORKS'">
                            <span v-for="(WorkData, workIndex) in innerData.works" :key="workIndex">
                              <span v-if="WorkData.member">
                                {{ handleUserName(WorkData.member) }}
                                {{
                                  workIndex + 1 === innerData.works.length
                                    ? ""
                                    : ","
                                }}
                              </span>
                            </span>
                          </span>
                          <span class="t-body3 font-r l-spacing42 pdl-4 t-color-bodyGrayA"
                            v-if="innerData.questionTextReply">{{ innerData.questionTextReply }}</span>
                        </span>
                        <div class="mgt-17 pda-16 bg-documentGray b-radius4" v-if="innerData.comment">
                          <div class="t-body3 font-r l-spacing42">
                            {{ $t("3369") }}
                          </div>
                          <div class="t-body3 font-r l-spacing42 t-color-bodyGrayA mgt-12">
                            {{ innerData.comment }}
                          </div>
                        </div>

                        <!-- 미디어 첨부파일을 보여주는 부분 -->
                        <div class="pda-16">
                          <div v-if="
                            Array.isArray(
                              innerData.images
                            ) &&
                            innerData.images
                              .length > 0
                          " class="image-scroll-wrapper">
                            <div class="image-list-horizontal">
                              <div class="image-item" v-for="(img, imgIdx) in innerData.images" :key="imgIdx">
                                <img v-if="getType(img.contentType) === 'image'" :src="img.resourceUri" alt=""
                                  class="chcklist-ans-image"
                                  @click="showImage(img)"
                                  @keypress="showImage(img)"
                                />
                                <video-player v-else :image="img" :imgHeight="104" :imgWidth="104"
                                  @click.native="showImage(img)"
                                  @keypress.native="showImage(img)"
                                  
                                ></video-player>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="d-flex align-items-center justify-content-between pdt-4 pdb-4 pdl-16 pdr-16">
          <div class="t-helper font-m flex-grow-1 t-color-bodyGrayB">
            {{ $t("3371") }}
          </div>
          <button class="mdc-icon-button mgr--16">
            <i class="material-icons t-headline12 t-color-bodyGrayA" id="listRemove" @click="addClass"
              @keypress="addClass" tabindex="0">keyboard_arrow_up</i>
          </button>
        </div>
        <div id="video-list" class="bg-documentGray">
          <header class="mdc-top-app-bar light-mode">
            <div class="mdc-top-app-bar__row">
              <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <button class="mdc-icon-button"></button>
              </section>
              <section class="mdc-top-app-bar__section title d-flex justify-content-center">
                <div class="mdc-top-app-bar__title pdl-1 font-r t-color-headlineBlackHigh">
                  {{ $t("3371") }}
                </div>
              </section>
              <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
                <button class="mdc-icon-button">
                  <i class="material-icons t-headline12 t-color-bodyGrayA" @click="removeClass" @keypress="removeClass"
                    tabindex="0">keyboard_arrow_down</i>
                </button>
              </section>
            </div>
          </header>
          <div class="lessonListing">
            <Comment @previewImage="showImageComment" />
          </div>
        </div>
      </div>
    </main>
    <image-preview v-if="showImagePreview" :imageFile="previewimageUrl" @closePreview="closePreview" />
  </section>
</template>

<script>
import { MDCMenu } from "@material/menu";
import checklistApi from "@/api/checklistApi.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import { fileMixin } from "@/mixins/file";
import { userMixin } from "../../mixins/user";
import Comment from "@/components/checklist/Comment.vue";
import InfiniteLoading from "vue-infinite-loading";
import UserImgProfile from "../common/checkUser/UserImgProfile.vue";

export default {
  data() {
    return {
      menuBar: null,
      detail: [],
      distributionDetail: null,
      contents: "",
      isNoData: false,
      showImagePreview: false,
      previewimageUrl: null,
      getMinutes: 0,
      getHours: 0,
      getDays: 0,
      getSeconds: 0,
      fromComment: false,
      brandName: localStorage.getItem("brandName"),
    };
  },

  components: {
    TopAppBarDrawer,
    InfiniteLoading,
    Comment,
    "image-preview": () => import("@/components/common/ImagePreview"),
    "video-player": () => import("@/components/common/VideoPlayer"),
    UserImgProfile,
  },

  mixins: [topAppBarMixin, fileMixin, userMixin],

  mounted() {
    console.log("I am submitted");
    this.distributionId = this.$route.params.postId;
    this.getDetail();
  },

  methods: {
    async goToBack() {
      if (this.$route.query.checkId) {
        this.$router.push({
          name: "CheckListView",
          params: { postId: this.$route.query.checkId },
        });
      } else {
        console.log("Checklist Submited Result go -1");
        this.$router.go(-1);
      }
    },

    addClass() {
      document.getElementById("video-list").classList.add("showList");
    },

    removeClass() {
      document.getElementById("video-list").classList.remove("showList");
    },

    showImageComment(imageUrl) {
      if (imageUrl) {
        this.showImagePreview = true;
        this.previewimageUrl = imageUrl;
        this.fromComment = true;
      }
    },

    myTriggerFunc() {
      if (document.querySelectorAll(".content-trigger")) {
        var contentTrigger = Array.from(
          document.querySelectorAll(".content-trigger")
        );
        contentTrigger.forEach((item) => {
          item.addEventListener("click", function () {
            if (this.firstChild.innerHTML === "keyboard_arrow_down") {
              this.firstChild.innerHTML = "keyboard_arrow_up";
            } else {
              this.firstChild.innerHTML = "keyboard_arrow_down";
            }
            this.parentNode.nextElementSibling.classList.toggle("d-none");
          });
        });
      }
    },

    getDetail() {
      this.$showLoading();
      checklistApi
        .submitCheckListDetails(this.$route.params)
        .then((response) => {
          this.distributionDetail = response.data.data;
          //	var seconds = (this.distributionDetail.lastSubmitDate.getTime() - this.distributionDetail.startDate.getTime()) / 1000;
          this.getSeconds =
            this.$moment(this.distributionDetail.lastSubmitDate).diff(
              this.$moment(this.distributionDetail.startDate),
              "seconds"
            ) % 60;
          this.getMinutes = this.$moment(
            this.distributionDetail.lastSubmitDate
          ).diff(this.$moment(this.distributionDetail.startDate), "minutes");
          if (this.getMinutes > 59 && this.getMinutes < 1440) {
            this.getHours = Math.trunc(this.getMinutes / 60);
            this.getMinutes = this.getMinutes % 60;
          } else if (this.getMinutes >= 1440) {
            this.getHours = Math.trunc(this.getMinutes / 60);
            if (this.getHours >= 24) {
              this.getDays = Math.trunc(this.getHours / 24);
              this.getHours = this.getHours % 24;
            }
            this.getMinutes = this.getMinutes % 60;
          }
          //	this.$moment(this.distributionDetail.startDate)
          this.$hideLoading();
          setTimeout(() => {
            this.myTriggerFunc();
          }, 10);
        })
        .catch((err) => {
          this.$hideLoading();
          this.$error({ content: err.errMsg }).then(() => { });
        });
    },

    askForModify() {
      this.$router.push({
        name: "BoardModify",
        params: {
          boardId: this.$route.params.boardId,
          postId: this.$route.params.postId,
        },
        query: this.$route.query,
      });
    },

    moveToQuestion() {
      this.$router.push({
        name: "CheckListQuestionTake",
        params: { postId: this.$route.params.postId },
      });
    },

    showImage(imageUrlData) {
      this.showImagePreview = true;
      this.previewimageUrl = imageUrlData;
    },

    closePreview() {
      // console.log('close preview')
      this.showImagePreview = false;
      this.previewimageUrl = null;
      if (this.fromComment == true) {
        this.fromComment = false;
        setTimeout(() => {
          this.myTriggerFunc();
          this.addClass();
        }, 0);
      } else {
        setTimeout(() => {
          this.myTriggerFunc();
        }, 0);
      }
    },

    goToPrevious() {
      if (this.$route.query && this.$route.query.fromPage == "main") {
        this.$router.push("/home");
      } else {
        this.$router.push(
          "/board/" +
          this.$route.params.boardId +
          "?boardName=" +
          encodeURI(this.$route.query.boardName) +
          "&categoryName=" +
          encodeURI(this.$route.query.categoryName)
        );
      }
    },
  },
};
</script>
<style scoped>
#video-list {
  transform: translateY(100%);
  display: none;
  transition: all 300ms ease-in-out;
}

.showList {
  display: block !important;
  position: fixed;
  bottom: 100%;
  width: 100%;
  z-index: 10000;
  height: 100%;
}

.drawer-profile-logo {
  font-size: 18px !important;
}

.checklist-comment-toggler {
  height: calc(100vh - 130px) !important;
  background-color: red;
}

.lessonListing {
  height: 100vh;
  padding-bottom: 147px;
}

.checklist-profile-img {
  margin-right: -16px;
}

.image-scroll-wrapper {
  overflow-x: auto;
}

.image-list-horizontal {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.image-item {
  position: relative;
  flex: 0 0 104px;
  width: 104px;
  height: 104px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chcklist-ans-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
</style>